import { ReactElement, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useGetUserinfo } from '../../hooks/queries/useGetUserinfo';
import { managerPathFor } from '../../pages/SafetyRounds/Round/roundView';

/**
 * The safety representative's part of the app (/verneombud). A general manager who is not a safety representative
 * never lands here: a link or an old email takes them to the same page in their own part of the app instead.
 */
export const SafetyRepArea = ({ children }: { children: ReactNode }): ReactElement | null => {
  const { pathname, search } = useLocation();
  const { data, isLoading } = useGetUserinfo();
  // Nothing is shown until the roles are known, so the page does not flash before moving
  if (isLoading) return null;
  const target = managerPathFor(pathname, search, data?.userRoles ?? []);
  return target ? <Navigate to={target} replace /> : <>{children}</>;
};
